<template>
  <div class="pk-session-table">
    <el-table :data="tableData" border style="width: 100%;" height="550">
      <el-table-column fixed prop="name" label="场次名">
      </el-table-column>
      <el-table-column prop="pkType" label="活动类型" width="120">
        <template slot-scope="scope">
          {{ scope.row.pkType === 0 ? '个人战' : '公会战' }}
        </template>
      </el-table-column>
      <el-table-column prop="orderId" label="排序" width="120">
      </el-table-column>
      <el-table-column prop="operator" label="操作人" width="120">
      </el-table-column>
      <el-table-column prop="startTimeStr" label="开始时间" width="200">
      </el-table-column>
      <el-table-column prop="endTimeStr" label="结束时间" width="200">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="250" align="center">
        <template slot="header" slot-scope="scope">
          <el-button type="text" size="small" @click="addSessionHandle(scope.row)">创建</el-button>
          <el-button type="text" size="small" @click="addBatchSessionHandle(scope.row)">批量创建</el-button>
        </template>
        <template slot-scope="scope">
          <el-button @click="handleViewPkDetail(scope.row)" type="text" size="small">查看</el-button>
          <el-button type="text" size="small" @click="handleEditSession(scope.row)">编辑</el-button>
          <el-button type="text" size="small" style="color: #ef696c;" @click="handleDelSession(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- pk详情弹窗 -->
    <pk-detail-dialog v-model="detailDialogVisible" :session-id="sessionId"></pk-detail-dialog>

    <!-- 批量创建场次弹窗 -->
    <el-dialog title="批量创建PK个次" :visible.sync="pkDetailCreateDialogData.visible" width="30%">
      <el-form :model="pkDetailCreateDialogData.data" label-width="80px" mode="left">
        <el-form-item label="个数">
          <el-input v-model="pkDetailCreateDialogData.num" autocomplete="off" type="number"></el-input>
        </el-form-item>
        <el-form-item label="PK类型" prop="pkType">
          <el-select v-model="pkDetailCreateDialogData.pkType" placeholder="请选择PK类型">
            <el-option label="个人战" :value="0"></el-option>
            <el-option label="公会战" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间段" v-for="(item, index) in pkDetailCreateDialogData.timeStrList" :key="index">
          <el-date-picker v-model="pkDetailCreateDialogData.timeStrList[index]" type="datetimerange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" align="right" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pkDetailCreateDialogData.visible = false">取 消</el-button>
        <el-button type="primary" @click="pkDetailAllHandle">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加/修改场次弹窗 -->
    <el-dialog :title="sessionDialogData.title" :visible.sync="sessionDialogData.visible" width="30%">
      <el-form :model="sessionDialogData.data" label-width="80px" mode="left">
        <el-form-item label="场次名称">
          <el-input v-model="sessionDialogData.data.name" autocomplete="off" placeholder="可不填"></el-input>
        </el-form-item>
        <el-form-item label="PK类型" prop="pkType">
          <el-select v-model="sessionDialogData.data.pkType" placeholder="请选择PK类型">
            <el-option label="个人战" :value="0"></el-option>
            <el-option label="公会战" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="sessionDialogData.data.orderId" autocomplete="off" placeholder="可不填"></el-input>
        </el-form-item>
        <el-form-item label="时间段">
          <el-date-picker @input="changeDate" v-model="sessionDialogData.data.dateRange" type="datetimerange"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sessionDialogData.visible = false">取 消</el-button>
        <el-button type="primary" @click="sessionSubmitHandle">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pkDetailDialog from './pk-detail-dialog.vue'
import { getPkSession, setPkSession, addPkSession, delPkSession, addPkSessionAll } from '@/api/pkRequest'
export default {
  components: {
    pkDetailDialog
  },
  props: {
    roundId: String
  },
  data() {
    return {
      sessionId: 0,
      detailDialogVisible: false,
      tableData: [],
      pkDetailCreateDialogData: {
        visible: false,
        num: 0,
        pkType: 0,
        timeStrList: []
      },
      sessionDialogData: {
        title: '添加场次',
        visible: false,
        isEdit: false,
        data: {
          id: null,
          pkType: 0,
          name: null,
          orderId: null,
          startTimeStr: '',
          endTimeStr: '',
          dateRange: []
        }
      }
    }
  },
  mounted() {
    if (this.roundId) {
      this.getPkSessionList()
    }
  },
  watch: {
    roundId(newVal) {
      this.getPkSessionList()
    },
    'pkDetailCreateDialogData.num': function (val) {
      this.pkDetailCreateDialogData.timeStrList = Array(Number(val)).fill([])
    }
  },
  methods: {
    // 请求弹框展示
    reqMessageShow(res) {
      if (res.code === 0) {
        this.$message({ type: 'success', message: "操作成功" })
        this.getPkSessionList()
      } else {
        this.$message({ type: 'warning', message: res.msg })
      }
    },
    // 获取pk场次列表
    async getPkSessionList() {
      const res = await getPkSession({ roundId: this.roundId })
      if (res.code === 0) {
        this.tableData = res.data
      } else {
        this.$message({
          type: 'warning',
          message: res.msg
        })
      }
    },
    // 提交集体创建pk场次操作
    async pkDetailAllHandle() {
      let timeStrList = this.pkDetailCreateDialogData.timeStrList.map(item => {
        return {
          startTimeStr: item[0],
          endTimeStr: item[1]
        }
      })

      console.log(timeStrList);
      const res = await addPkSessionAll({
        roundId: this.roundId,
        num: this.pkDetailCreateDialogData.num,
        pkType: this.pkDetailCreateDialogData.pkType,
        timeStrList: timeStrList
      })

      this.reqMessageShow(res)
      this.pkDetailCreateDialogData.visible = false
    },
    // 具体pk信息弹窗展示
    handleViewPkDetail(row) {
      this.sessionId = row.id
      this.detailDialogVisible = true

    },

    // 删除pk场次
    async handleDelSession(row) {
      try {
        await this.$confirm('此操作将永久删除该场次, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const res = await delPkSession({ id: row.id })
        this.reqMessageShow(res)
      } catch (error) {
      }
    },
    // 添加场次初始化
    addSessionHandle() {
      this.sessionDialogData.title = '添加场次'
      this.sessionDialogData.isEdit = false
      this.sessionDialogData.visible = true
      this.sessionDialogData.data = {
        id: null,
        pkType: 0,
        name: null,
        orderId: null,
        startTimeStr: '',
        endTimeStr: '',
        dateRange: []
      }
    },
    // 修改场次初始化
    handleEditSession(row) {
      this.sessionDialogData.title = '修改场次'
      this.sessionDialogData.isEdit = true
      this.sessionDialogData.visible = true
      this.sessionDialogData.data = row
      this.sessionDialogData.data.dateRange = [row.startTimeStr, row.endTimeStr]
    },
    // 集体创建pk场次初始化
    addBatchSessionHandle() {
      this.pkDetailCreateDialogData = {
        visible: true,
        num: 0,
        pkType: 0,
        timeStrList: []
      }
    },
    changeDate() {
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    async sessionSubmitHandle() {
      let res = null
      if (this.sessionDialogData.isEdit) {
        res = await setPkSession({
          id: this.sessionDialogData.data.id,
          name: this.sessionDialogData.data.name,
          pkType: this.sessionDialogData.data.pkType,
          orderId: this.sessionDialogData.data.orderId,
          operator: this.$store.getters.username,
          startTimeStr: this.sessionDialogData.data.dateRange[0],
          endTimeStr: this.sessionDialogData.data.dateRange[1]
        })
      } else {
        res = await addPkSession({
          roundId: this.roundId,
          name: this.sessionDialogData.data.name,
          pkType: this.sessionDialogData.data.pkType,
          orderId: this.sessionDialogData.data.orderId,
          operator: this.$store.getters.username,
          startTimeStr: this.sessionDialogData.data.dateRange[0],
          endTimeStr: this.sessionDialogData.data.dateRange[1]
        })
      }
      this.sessionDialogData.visible = false
      this.reqMessageShow(res)
    }
  }
}
</script>


<style scoped lang ="scss">
</style>
